import client from './client';

export const usersApi = {
  // List all users (admin only)
  async list(params = {}) {
    const { data } = await client.get('/api/users', { params });
    return data;
  },

  // Update user (approve, disable, change role)
  async update(userId, updates) {
    const { data } = await client.patch(`/api/users/${userId}`, updates);
    return data;
  },

  // Approve user
  async approve(userId) {
    return this.update(userId, { status: 'approved' });
  },

  // Disable user
  async disable(userId) {
    return this.update(userId, { status: 'disabled' });
  },
};
